import { Card, Content, Table, TableBody } from "@ssf/components";
import { gameSchema, z } from "@ssf/play-common";
import {
  equalTo,
  GameRow,
  GameRowHead,
  gamesRef,
  orderByChild,
  useValue,
} from "@ssf/play-components";
import { SwordCross } from "mdi-material-ui";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { generatePath } from "../lib/routes.js";

const schema = z.record(gameSchema);

const useMyGames = (memberId: number) => {
  const path = [gamesRef, "yes2chess"];
  const uid = `memdb_${memberId}`;

  const { data: gamesWhite } = useValue(...path)({
    // biome-ignore lint/correctness/useExhaustiveDependencies: Observer
    queryConstraints: useMemo(
      () => [orderByChild("white/uid"), equalTo(uid)],
      [memberId],
    ),
    schema,
  });
  const { data: gamesBlack } = useValue(...path)({
    // biome-ignore lint/correctness/useExhaustiveDependencies: Observer
    queryConstraints: useMemo(
      () => [orderByChild("black/uid"), equalTo(uid)],
      [memberId],
    ),
    schema,
  });

  return { ...gamesWhite, ...gamesBlack };
};

export const MyGames = ({ memberId }: { memberId: number }) => {
  const { t } = useTranslation("MyGames");
  const games = Object.entries(useMyGames(memberId));

  if (!games.length) {
    return null;
  }

  return (
    <Content>
      <Card
        title={t("title")}
        icon={<SwordCross />}
        disablePadding
        paperProps={{ sx: { overflow: "auto" } }}
      >
        <Table size="small" sx={{ tableLayout: "fixed" }}>
          <GameRowHead />
          <TableBody>
            {games.map(([gid, game]) => {
              const [matchId, board] = gid.replace("memdb_", "").split("-");
              return (
                <GameRow
                  key={gid}
                  game={game}
                  // @ts-ignore
                  component={Link}
                  to={generatePath("game", { matchId, board })}
                />
              );
            })}
          </TableBody>
        </Table>
      </Card>
    </Content>
  );
};
